// ->AppControlMessageTypes.ts on WebClient side

// external messages
export const DataRequest = "DataRequest";
export const InitPort = "InitPort";

// internal Messages
export const ServiceWorkerSetupDone = "ServiceWorkerSetupDone";

export const GetCookies = "GetCookies";
export const CookieResponse = "CookieResponse";
export const SetCookies = "SetCookies";
